import { render } from "./CounterpartyTypeComponent.vue?vue&type=template&id=119a635c&ts=true"
import script from "./CounterpartyTypeComponent.vue?vue&type=script&lang=ts"
export * from "./CounterpartyTypeComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__